module.exports = __webpack_public_path__ + "static/media/login-partner-icon.f0bd4d88.svg";